// Liveblog iframe size handling.
import './liveblog-iframe.scss';
import iFrameResize from 'iframe-resizer/js/iframeResizer';
import domContentLoaded from 'utils/domContentLoaded';

const liveblogIframeResize = () => {
  const liveblogIframe = document.getElementById('liveblog-iframe');

  if (! liveblogIframe) {
    return;
  }

  iFrameResize({ log: true, heightCalculationMethod: 'max' }, liveblogIframe);
};

domContentLoaded(() => {
  liveblogIframeResize();
});
